import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { CareerBox } from './CareerBox';
import { Job } from '@/types/job';
export const CareerBoxes = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items?.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-2 lg:gap-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(props, index) {
  return <CareerBox key={index} {...props} />;
}